import {Component} from "react";

export class SellToWebTableColumnSparklineComponent extends Component {
}